<template>
  <div>
    <el-row>
     <el-col style="width: 350px" align="left">
        <div class="option-label" style="margin-left: 10px; padding-bottom: 5px; padding-top: 10px">Show</div>
        <el-radio-group v-model="plotOrganism" size="small" style="margin-left: 10px">
          <el-tooltip class="item" content="Plot data for the current organism" effect="dark" placement="top" :enterable="false">
            <el-radio-button label="current">Current Organism</el-radio-button>
          </el-tooltip>
          <el-tooltip class="item" content="Compare data for all selected organisms" effect="dark" placement="top" :enterable="false">
            <el-radio-button label="all">All selected Organisms</el-radio-button>
          </el-tooltip>
        </el-radio-group>
      </el-col>

      <el-col style="width: 250px" align="left">
        <div class="option-label" style="padding-bottom: 5px; padding-top: 10px">Select repeats</div>
        <el-select v-model="plotOptions.selected" collapse-tags multiple filterable
          placeholder="Select repeats" style="width: 90%" size="small">
          <el-option-group v-for="group in repeatsMultiSelectOptions" :key="group.label" :label="group.label">
            <el-option v-for="item in group.options" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-option-group>
        </el-select>
      </el-col>

      <el-col style="width: 500px" align="left">
        <div class="option-label" style="padding-bottom: 5px; padding-top: 10px">Length range </div>
        <el-select v-model="plotOptions.lengthType" size="small" style="width: 120px; margin-right: 10px">
          <el-option selected value="bases" label="Base pairs"></el-option>
          <el-option value="units" label="Unit motifs"></el-option>
        </el-select>
        <span style="font-size: 1.1em">Min:</span> <el-input-number v-model="plotOptions.min" style="width: 100px; margin-left: 10px; margin-right: 20px" size="small" ></el-input-number>
        <span style="font-size: 1.1em">Max:</span> <el-input-number v-model="plotOptions.max" style="width: 100px; margin-left: 10px" size="small" ></el-input-number>
      </el-col>

    </el-row>

    <el-row v-if="plotOrganism === 'current'" style="margin-top: 20px">
      <modal-unit-line-len-frequency height="70vh" :series="lineLenFrequencyData[store.species.order.indexOf(store.species.current)]"></modal-unit-line-len-frequency>
    </el-row>

    <div v-if="plotOrganism === 'all'">

      <el-row style="padding-bottom: 15px; padding-top: 10px">
        
        <el-col style="width: 350px" align="left">
          <div class="option-label" style="padding-bottom: 5px; padding-top: 10px; margin-left: 10px">Data type </div>
          <el-radio-group v-model="plotOptions.datatype" size="small" style="margin-left: 10px">
            <el-radio label="density" border>Density</el-radio>
            <el-radio label="frequency" border>Frequency</el-radio>
          </el-radio-group>
        </el-col>
        
        <el-col style="width: 250px" align="left">
          <div class="option-label" style="padding-bottom: 5px; padding-top: 10px">Group by </div>
          <el-switch style="display: block" v-model="plotOptions.groupByRepeat" inactive-color="#13ce66"
            active-color="#13ce66" active-text="Repeat" inactive-text="Organism"></el-switch>
        </el-col>

      </el-row>


      <el-row :gutter="15" v-if="!(plotOptions.groupByRepeat)">
        <el-col :lg="8" :md="12" :sm="12" :xs="24" v-for="(organism, index) in store.species.order" :key="organism"
          style="margin-top: 30px">
          <modal-unit-line-len-frequency :index="index+1" :series="lineLenFrequencyData[index]"></modal-unit-line-len-frequency>
        </el-col>
      </el-row>

      <el-row :gutter="15" v-if="plotOptions.groupByRepeat" >
        <el-col :lg="8" :md="12" :sm="12" :xs="24" v-for="(repeat, index) in plotOptions.selected" :key="repeat"
          style="margin-top: 30px">
          <modal-unit-line-len-frequency :index="index+1" :series="lineLenFrequencyData[index]"></modal-unit-line-len-frequency>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { store } from '../scripts/store.js'
import ModalUnitLineLenFrequency from '../components/ModalUnitLineLenFrequency.vue'
import { repeatsMultiSelectOptions } from '../scripts/repeatsMultiSelectOptions.js'

export default {
  name: 'ModalLineLenFrequency',
  components: { ModalUnitLineLenFrequency },
  data() {
      return {
        store: store,
        plotOrganism: "current",
        repeatsMultiSelectOptions: repeatsMultiSelectOptions,
        plotOptions: {
          lengthType: 'bases',
          min: 12,
          max: 50,
          selected: ["A", "C", "AC", "AG", "AT", "CG"],
          datatype: "density",
          groupByRepeat: false
        }
      }
    },
    computed: {

      lineLenFrequencyData: function() {
        let parameters = this.plotOptions;
        let linedata = [];
        const organisms = this.store.species.order;
        const info = this.store.info;
        const lengthType = parameters.lengthType;

        const repeats = parameters.selected;
        const minLength = parameters.min;
        const maxLength = parameters.max;

        if (this.plotOrganism === "current") { this.plotOptions.datatype = "frequency" }

        organisms.forEach((o, i) => {
          let series = [];
          const orginfo = info.filter(a => { return a.OrgInfo.MSDBID === o; })[0];
          let organismName = orginfo.OrgInfo.OrganismName;
          const genomeSize = parseInt(orginfo.GenomeInfo.GenomeSize);
          const plotdata = orginfo.RepInfo.PlotData;
          for (let rep of repeats) {
            let obj = {};
            obj.name = rep;
            obj.type = 'line';
            obj.data = [];
            obj.showSymbol = false;
            let lengths = _.range(minLength, maxLength + 1);
            if (lengthType === "bases") {
              lengths.forEach(function(l) {
                if (l < 12) { obj.data.push(undefined) } 
                else {
                  let val = _.sum(plotdata[rep][l]);
                  if (parameters.datatype === "density") { val = ((val*1000000)/genomeSize).toFixed(2) }
                  obj.data.push(val);
                }
              })
            }
            else {
              const motif_length = rep.length;
              lengths.forEach(function(u){
                if (u*motif_length >= 12) {
                  let val = 0;
                  for (let l in _.range(motif_length)) {
                    l = u*motif_length + parseInt(l);
                    val += _.sum(plotdata[rep][l]);
                  }
                  if (parameters.datatype === "density") { val = ((val*1000000)/genomeSize).toFixed(2) }
                  obj.data.push(val);
                }
                else { obj.data.push(undefined); }
              })
            }
            series.push(obj);
          }
          if (organismName.length > 25) { organismName = organismName.slice(0, 25) + '...' }
          linedata.push({title: organismName, data: series, x: _.range(minLength, maxLength + 1), datatype: parameters.datatype, lengthType: parameters.lengthType})
        })

        if ((parameters.groupByRepeat) && (this.plotOrganism != "current")) {
          let series = [];
          let templinedata = [];
          repeats.forEach((r, i) => {
            templinedata.push({ title: r, x: _.range(minLength, maxLength + 1), data: [] });
            linedata.forEach(b => {
              const name = b.title;
              const value = b.data.filter(d => {return d.name === r;})[0].data;
              templinedata[i]['data'].push({name: name, type: 'line', data: value, datatype: parameters.datatype, showSymbol: false, lengthType: parameters.lengthType});
            })
          })
          linedata = templinedata;
        }
        return linedata;
      }
    }
}
</script>

<style>
.option-label {
  font-weight: bold;
  /* color: #102E59; */
  /* font-size: 1.2em; */
  /* color: black; */
}